import React, { useState } from "react";
import {
  ActivityIndicator,
  Modal,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { ImageZoom } from "@likashefqet/react-native-image-zoom";
import { GestureHandlerRootView } from "react-native-gesture-handler";

import { type EventImage } from "@/schemas/events/EventMedia";

type ImageModalProps = {
  image: EventImage;
  onClose: () => void;
};

function EventImageModal({
  image,
  onClose,
}: ImageModalProps): React.JSX.Element {
  const [isLoading, setIsLoading] = useState(true);
  // GHRV is required on Android.
  // https://github.com/likashefqet/react-native-image-zoom?tab=readme-ov-file

  return (
    <Modal transparent={true}>
      <GestureHandlerRootView>
        <View style={styles.container}>
          <TouchableOpacity
            style={styles.imageContainer}
            onPress={() => onClose()}
          >
            <ImageZoom
              source={image.uri}
              style={styles.image}
              onLoadStart={() => setIsLoading(true)}
              onLoad={() => setIsLoading(false)}
            />
            {isLoading && (
              <ActivityIndicator
                size="large"
                color="#ffffff"
                style={styles.loadingIndicator}
              />
            )}
          </TouchableOpacity>
        </View>
      </GestureHandlerRootView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  loadingIndicator: {
    position: "absolute",
    alignSelf: "center",
  },
  container: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    flex: 1,
    justifyContent: "center",
  },
  image: {
    maxHeight: "100%",
    width: "100%",
    resizeMode: "stretch",
  },
  imageContainer: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flex: 1,
  },
});

export default EventImageModal;
